import { DropIcon } from "../../_components/Imagepath";
import TextEditor from "./editor";
import { Form, Field } from "react-final-form";

const AddProductForm = ({ isEdit, id, data }) => {
  const onSubmit = (values) => {
    console.log("Form submitted with values:", values);
    let payload = { ...values };
    if (values.image && values.image[0]) {
      payload = { ...payload, image: values.image[0] };
    } else {
      const { ...rest } = payload;
      payload = rest;
    }
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (key === "image" && value) {
        formData.append(key, value);
      } else if (key !== "image") {
        formData.append(key, value);
      }
    });

    const url = isEdit ? `/products/${id}/edit/` : "/products/add-product/";
    const method = isEdit ? "PUT" : "POST";
    fetch(url, {
      method,
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Product added successfully:", data);
        if(data?.success){
          window.location.href = "/products/";
        }
      })
      .catch((err) => {
        console.error("Error adding product:", err);
      });
  };
  return (
    <Form
      onSubmit={onSubmit}
      initialValues={isEdit ? data : {}}
      render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="input-block mb-3">
              <label>
                {
console.log(values)

                }
                Product Name <span className="text-danger"> *</span>
              </label>
              <Field
                name="name"
                component="input"
                type="text"
                className="form-control"
                placeholder="Enter Product Name"
                required
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12">
            <div className="input-block mb-3 add-products">
              <label>
                Product Code (SKU)
                <span className="text-danger"> *</span>
              </label>
              <Field
                name="sku"
                component="input"
                type="text"
                className="form-control"
                placeholder="Enter Product Code"
                required
              />
            </div>
          </div>
          <div className="form-group-item">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6 col-12 description-box" >
                <div className="input-block mb-3" style={{marginLeft :15}} id="summernote_container">
                  <label className="form-control-label">
                    Product Descriptions
                  </label>
                  <Field name="description">
                    {({ input }) => (
                      <TextEditor
                        value={input.value}
                        // onChange={input.onChange}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          input.onChange(data);
                        }}
                      />
                    )}
                  </Field>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-12">
                <div className="input-block mb-3">
                  <label>Product Image</label>
                  {values.image ? (
                    <div className="input-block mb-3 service-upload mb-0">
                      {values.image && (
                        <img
                          src={
                            typeof values.image === "string"
                              ? values.image 
                              : URL.createObjectURL(values.image?.[0])
                          }
                          alt="upload"
                          style={{
                            maxHeight: "140px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                      <span
                        className="text-primary ms-1"
                        onClick={() => form.change("image", null)}
                        style={{ cursor: "pointer" }}
                      >
                        Remove
                      </span>
                    </div>
                  ) : (
                    <div className="input-block mb-3 service-upload mb-0">
                      <span>
                        <img src={DropIcon} alt="upload" />
                      </span>
                      <h6 className="drop-browse align-center">
                        Drop your files here or
                        <span className="text-primary ms-1">browse</span>
                      </h6>
                      <p className="text-muted">Maximum size: 50MB</p>
                      <Field name="image">
                        {({ input }) => {
                          return (
                            <input
                              type="file"
                              multiple
                              id="image_sign"
                              onChange={(e) => input.onChange(e.target.files)}
                            />
                          );
                        }}
                      </Field>
                      <div id="frames" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 text-end">
            <button
              type="button"
              className="btn btn-primary cancel me-2"
              onClick={form.reset}
              disabled={submitting || pristine}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              disabled={submitting}
            >
              {isEdit ? "Update Product" : "Add Product"}
            </button>
          </div>
        </form>
      )}
    />
  );
};

export default AddProductForm;
